// Compiled at 2026-09-18T12:45:23.979Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { addQueryParametersToUrl } from "@lg/shared/for-apps";
import type { ScreenDefinition } from "@lg/shared";
import { VendorOffersProcess } from "../../Screen/Orders/VendorOffersProcess.js";
import { VendorOffersInclude } from "../../Screen/Orders/VendorOffersInclude.js";
import { VendorOfferList } from "../../Screen/Orders/VendorOfferList.js";
import { VendorHistoryInclude } from "../../Screen/Orders/VendorHistoryInclude.js";
import { Tasks } from "../../Screen/Orders/Tasks.js";
import { MetadataManage } from "../../Screen/Orders/MetadataManage.js";
import { MainLayoutSidebar } from "../../Screen/Orders/MainLayoutSidebar.js";
import { MainLayoutHeader } from "../../Screen/Orders/MainLayoutHeader.js";
import { MainLayout } from "../../Screen/Orders/MainLayout.js";
import { Login } from "../../Screen/Orders/Login.js";
import { Home } from "../../Screen/Orders/Home.js";
import { CustomerRequestViewInclude } from "../../Screen/Orders/CustomerRequestViewInclude.js";
import { CustomerRequestView } from "../../Screen/Orders/CustomerRequestView.js";
import { CustomerRequestProcess } from "../../Screen/Orders/CustomerRequestProcess.js";
import { CustomerRequestList } from "../../Screen/Orders/CustomerRequestList.js";
import { CustomerRequestInclude } from "../../Screen/Orders/CustomerRequestInclude.js";
import { CustomerOrderProcess } from "../../Screen/Orders/CustomerOrderProcess.js";
import { CustomerHistoryInclude } from "../../Screen/Orders/CustomerHistoryInclude.js";
import { VendorOffersComparisonInclude } from "../../Screen/Orders/VendorOffersComparisonInclude.js";
import { FrontendScreenBridge } from "@lg/ng-shared";

export const $Screens = {
    VendorOffersProcess: {
        moduleId: 'Orders', boId: 'VendorOffersProcess', get component() { return VendorOffersProcess }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/VendorOffersProcess', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        request: This.CustomerRequest,
    }, {
        submit: This.CustomerRequest,
        save: This.CustomerRequest,
    }>,
    VendorOffersInclude: {
        moduleId: 'Orders', boId: 'VendorOffersInclude', get component() { return VendorOffersInclude }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/VendorOffersInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        request: This.CustomerRequest,
        highlightOfferId: This.VendorOffer.Id | undefined,
    }, {
        submit: This.CustomerRequest,
    }>,
    VendorOfferList: {
        moduleId: 'Orders', boId: 'VendorOfferList', get component() { return VendorOfferList }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/VendorOfferList', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
        filter?: string,
    }, {
        }, {
            submit: This.CustomerRequest,
        }>,
    VendorHistoryInclude: {
        moduleId: 'Orders', boId: 'VendorHistoryInclude', get component() { return VendorHistoryInclude }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/VendorHistoryInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        vendorId: This.Vendor.Id,
        referenceRequest: This.CustomerRequest,
    }, {
        }>,
    Tasks: {
        moduleId: 'Orders', boId: 'Tasks', get component() { return Tasks }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/Tasks', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    MetadataManage: {
        moduleId: 'Orders', boId: 'MetadataManage', get component() { return MetadataManage }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/MetadataManage', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    MainLayoutSidebar: {
        moduleId: 'Orders', boId: 'MainLayoutSidebar', get component() { return MainLayoutSidebar }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/MainLayoutSidebar', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    MainLayoutHeader: {
        moduleId: 'Orders', boId: 'MainLayoutHeader', get component() { return MainLayoutHeader }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/MainLayoutHeader', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    MainLayout: {
        moduleId: 'Orders', boId: 'MainLayout', get component() { return MainLayout }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/MainLayout', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        screenTitle?: string,
        isForExternalUser?: boolean,
    }, {
        }>,
    Login: {
        moduleId: 'Orders', boId: 'Login', get component() { return Login }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/Login', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        redirect: string,
    }, {
        }>,
    Home: {
        moduleId: 'Orders', boId: 'Home', get component() { return Home }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/Home', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    CustomerRequestViewInclude: {
        moduleId: 'Orders', boId: 'CustomerRequestViewInclude', get component() { return CustomerRequestViewInclude }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/CustomerRequestViewInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        request: This.CustomerRequest,
        offerId: This.VendorOffer.Id | undefined,
    }, {
        }>,
    CustomerRequestView: {
        moduleId: 'Orders', boId: 'CustomerRequestView', get component() { return CustomerRequestView }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/CustomerRequestView', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
        requestId: This.CustomerRequest.Id,
        offerId: This.VendorOffer.Id | undefined,
    }, {
        }, {
        }>,
    CustomerRequestProcess: {
        moduleId: 'Orders', boId: 'CustomerRequestProcess', get component() { return CustomerRequestProcess }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/CustomerRequestProcess', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        request: This.CustomerRequest,
    }, {
        submit: This.CustomerRequest,
        close: {
            delete: boolean,
        },
    }>,
    CustomerRequestList: {
        moduleId: 'Orders', boId: 'CustomerRequestList', get component() { return CustomerRequestList }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/CustomerRequestList', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
        filter?: string,
    }, {
        }, {
            submit: This.CustomerRequest,
        }>,
    CustomerRequestInclude: {
        moduleId: 'Orders', boId: 'CustomerRequestInclude', get component() { return CustomerRequestInclude }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/CustomerRequestInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        request: This.CustomerRequest,
        setVendorSelection?: boolean,
    }, {
        }>,
    CustomerOrderProcess: {
        moduleId: 'Orders', boId: 'CustomerOrderProcess', get component() { return CustomerOrderProcess }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/CustomerOrderProcess', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        request: This.CustomerRequest,
        mail: Sys.Types.Mail,
        mailTimestamp: number,
    }, {
        submit: null,
    }>,
    CustomerHistoryInclude: {
        moduleId: 'Orders', boId: 'CustomerHistoryInclude', get component() { return CustomerHistoryInclude }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/CustomerHistoryInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        customerDomain: string,
        referenceRequest: This.CustomerRequest | undefined,
    }, {
        }>,
    VendorOffersComparisonInclude: {
        moduleId: 'Orders', boId: 'VendorOffersComparisonInclude', get component() { return VendorOffersComparisonInclude }, getFullUrl(params) {
            return addQueryParametersToUrl('/Orders/VendorOffersComparisonInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        request: This.CustomerRequest,
        highlightOfferId: This.VendorOffer.Id | undefined,
    }, {
        submit: This.CustomerRequest,
    }>,
};
